import React from 'react';
import { ReactComponent as IconoMovil } from '.././imagenes/movil.svg';

const IconoEstadoConductor = ({estado}) => {

    switch(estado){
        case 'validar_vehiculo':
            return <IconoMovil fill="orange"/>;
        case 'Asignado' :
            return <IconoMovil fill="blue"/>;
        case 'activo' :
            return <IconoMovil fill="green"/>;
        case 'aprobacion_central' :
            return <IconoMovil fill="red"/>;
        default :
            return <IconoMovil/>;
    }
}
export default IconoEstadoConductor;